
import type { PropType } from 'vue'
import type { BrowseFacetDTO } from '../../models'

import { defineComponent, ref, watch } from 'vue'

import { isNonSortableFacetType } from '../../composables/use-facets'
import { ColorEnum } from '../../enums'
import { capitalizeSentence } from '../../filters'

import { EpbBadge } from '../shared/epb-badge'
import { EpbText } from '../shared/epb-text'
import XTogglePanel from '../x/x-toggle-panel.component.vue'

import EpbRecursiveFacetValues from './epb-recursive-facet-values.component.vue'

export default defineComponent({
  name: 'EpbFacetsContainer',
  components: { EpbBadge, EpbText, EpbRecursiveFacetValues, XTogglePanel },
  props: {
    facet: {
      type: Object as PropType<BrowseFacetDTO>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const baseClass = 'epb-facets-container'

    const facetValues = ref(props.facet?.values)

    watch(
      () => props.facet,
      () => {
        facetValues.value = props.facet?.values
      },
      { immediate: true },
    )

    return {
      baseClass,
      facetValues,
      ColorEnum,
      capitalizeSentence,
      isNonSortableFacetType,
    }
  },
})
